// extracted by mini-css-extract-plugin
export default {"card":"Card_card__pqOY8","shadow":"Card_shadow__VFTxq"};